module.exports = __webpack_public_path__ + "static/media/d.1894526c.png";